import React from "react";
import "./Footer.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFire } from "@fortawesome/free-solid-svg-icons";
// import logo_edm from "../../assets/logo_edm.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

//   const navigate = useNavigate;

//   const goToBimbelSnbt = () => {
//     navigate("/bimbel-snbt-terbaik");
//   };

//   const goToBimbelTni = () => {
//     navigate("/bimbel-tni-polri-dan-sekolah-kedinasan");
//   };

//   const goToBimbelOsn = () => {
//     navigate("/bimbel-osn");
//   };

  return (
    <div className="pg-bawah">
      <footer className="bawah">
        <div className="parent-line">
        </div>
        <div className="bawah-content">
          <div className="bawah-content-column">
            <div className="bawah-logo">
              <a className="bawah-logo-link" href="#">
                <span className="hidden-link-text"></span>
                <img
                  className="logo-bawah"
                  src="https://tarunapersada.com/assets/img/logo/Taruna_Persada_tanpa_byedumatrix.png"
                  alt="Bimbel Masuk Akpol Akmil - Taruna Persada"
                />
              </a>
            </div>
            <div className="bawah-menu">
              <ul id="menu-get-started" className="bawah-menu-list">
                <li className="menu-item menu-item-type-post_type menu-item-object-product">
                  <a className="link-footer" href="#">
                    Ruko Permai Monjali
                  </a>
                  <p className="p-address">
                    Jalan Monjali No 3, Kutu Dukuh, Sinduadi, Mlati, Sleman,
                    Yogyakarta 55241
                  </p>
                  <div className="all-sosmed">
                    <a
                      className="sosmed-bawah"
                      href="https://www.instagram.com/tarunapersadaofficial"
                    >
                      <img
                        className="img-sosmed"
                        src="https://cdn-web-2.ruangguru.com/landing-pages/assets/hs/1%20Homepage%20RG/Optimize%20V2/ic-ig.svg?convert=webp"
                        alt="Bimbel Masuk Akpol Akmil - Taruna Persada"
                      />
                    </a>
                    <a className="sosmed-bawah" href="https://www.facebook.com/profile.php?id=61559742302801&mibextid=ZbWKwL">
                      <img
                        className="img-sosmed"
                        src="https://cdn-web-2.ruangguru.com/landing-pages/assets/hs/1%20Homepage%20RG/Optimize%20V2/ic-fb.svg?convert=webp"
                        alt="Bimbel Masuk Akpol Akmil - Taruna Persada"
                      />
                    </a>
                    <a
                      className="sosmed-bawah"
                      href="https://youtube.com/@tarunapersadaofficial"
                    >
                      <img
                        className="img-sosmed"
                        src="https://cdn-web-2.ruangguru.com/landing-pages/assets/hs/1%20Homepage%20RG/Optimize%20V2/ic-youtube.svg?convert=webp"
                        alt="Bimbel Masuk Akpol Akmil - Taruna Persada"
                      />
                    </a>
                    <a
                      className="sosmed-bawah"
                      href="https://www.tiktok.com/@tarunapersadaofficial"
                    >
                      <img
                        className="img-sosmed"
                        src="https://cdn-web-2.ruangguru.com/landing-pages/assets/hs/1%20Homepage%20RG/Optimize%20V2/tiktok-ic-white-40.svg?convert=webp"
                        alt="Bimbel Masuk Akpol Akmil - Taruna Persada"
                      />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="bawah-content-column">
            <div className="bawah-menu">
              <h2 className="bawah-menu-name"> Konsultasi Program</h2>
              <ul id="menu-company" className="bawah-menu-list">
                {/* <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a className="link-footer">0857-1221-7876 (Kak Una)</a>
                </li>
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a className="link-footer">0856-0042-2188 (Kak Sari)</a>
                </li> */}
                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a className="link-footer">0812-1636-5729 (Kak Nia)</a>
                </li>
                <li className="menu-item menu-item-type-taxonomy menu-item-object-category">
                  <a className="link-footer">0856-0042-2188 (Kak Dila)</a>
                </li>
                {/* <li className="menu-item menu-item-type-post_type menu-item-object-page">
                  <a className="link-footer">0812-1552-3902 (Kak Eka)</a>
                </li> */}
              </ul>
            </div>
            <div className="bawah-menu">
              <h2 className="bawah-menu-name">Hot Program</h2>
              <ul id="menu-legal" className="bawah-menu-list">
                <li className="menu-item-hot-program menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-170434">
                  <a
                    className="link-footer-hot-program"
                  >
                    Bimbel AKPOL🔥
                  </a>
                </li>
                <br />
                <li className="menu-item-hot-program menu-item-type-post_type menu-item-object-page">
                  <a
                    className="link-footer-hot-program"
                  >
                    Bimbel AKADEMI TNI🔥
                  </a>
                </li>
                <br />
                <li className="menu-item-hot-program menu-item-type-post_type menu-item-object-page">
                  <a
                    className="link-footer-hot-program"
                  >
                    Bimbel TNI - POLRI🔥
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="bawah-content-column">
            <div className="bawah-menu">
              <h2 className="bawah-menu-name">other websites</h2>
              <ul id="menu-quick-links" className="bawah-menu-list">
                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-footer"
                    href="https://tarunapersada.com"
                  >
                    TARUNAPERSADA.COM
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="bawah-content-column">
            <div className="bawah-call-to-action">
              <h2 className="bawah-call-to-action-title"> Konsultasi Gratis</h2>
              <p className="bawah-call-to-action-description">
                {" "}
                Punya Pertanyaan?
              </p>
              <a
                className="bawah-call-to-action-button button"
                href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%201%20Bagaimana%20penjelasan%20detail%20Programnya?"
                target="_self"
              >
                {" "}
                <strong>Hubungi Kami</strong>
              </a>
            </div>
            {/* <div className="bawah-call-to-action">
              <h2 className="bawah-call-to-action-title"> Kontak Umum</h2>
              <p className="bawah-call-to-action-link-wrapper">
                {" "}
                <a
                  className="bawah-call-to-action-link"
                  href="tel:085600422188"
                  target="_self"
                >
                  {" "}
                  +62 856-0042-2188
                </a>
              </p>
            </div> */}
          </div>
        </div>
        {/* <div className="parent-line">
          <hr className="garis-end-2" />
        </div> */}
        <div className="bawah-copyright">
          <div className="bawah-copyright-wrapper">
            <p className="bawah-copyright-text">
              <a className="bawah-copyright-link" href="" target="_self">
                ©{currentYear}. | Taruna Persada | All rights reserved.{" "}
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;